import {
    GET_AMAZON_PRODUCT_UPDATE_REQUEST,
    GET_AMAZON_PRODUCT_UPDATE_SUCCESS,
    GET_AMAZON_PRODUCT_UPDATE_ERROR
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_AMAZON_PRODUCT_UPDATE_REQUEST:
            return {
                loading: true,
            };
        case GET_AMAZON_PRODUCT_UPDATE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_AMAZON_PRODUCT_UPDATE_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}